// OfficeInfo.js
import React from 'react';

const OfficeInfo = ({ info }) => {
  if (!info) return null;
  return (
    <div className="office-info">
      <h2>{info.name}</h2>
      <p>{info.message}</p>
    </div>
  );
};

export default OfficeInfo;
